import debug from "src/modules/debug-logger";
import { Type } from "./proto-root";
import protobuf from "protobufjs";

// const protobuf = window.require("protobufjs");

export { default } from "./proto-root";

export function createPushNotification({
  iosPayload,
  androidPayload,
  channel
}) {
  debug.pushNotification(`About to create PushNotification`);
  debug.pushNotification(`iosPayload`, iosPayload);
  debug.pushNotification(`androidPayload`, androidPayload);
  const pushNotification = Type.PushNotification.create({
    iosPushNotification: Type.IOSPushNotification.create({
      payload: JSON.stringify(iosPayload)
    }),
    androidPushNotification: Type.AndroidPushNotification.create({
      data: JSON.stringify(androidPayload)
    }),
    channel
  });
  const asBuffer = Type.PushNotification.encode(pushNotification).finish();
  return protobuf.util.base64.encode(asBuffer, 0, asBuffer.length);
}
